import AdminDashboard from "../pages/Admin/Dashboard/AdminDashboard";

import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import Profile from "../pages/Admin/Profile/Profile";
import Users from "../pages/Admin/Users/Users";
import Staff from "../pages/Admin/Staff/Staff";
import CourseCategory from "../pages/Admin/CourseCategory/CourseCategory";
import Organization from "../pages/Admin/Organization/Organization";
import Interest from "../pages/Admin/Interest/Interest";
import Skill from "../pages/Admin/Skill/Skill";
import Mentor from "../pages/Admin/Mentor/Mentor";
import MentorDetails from "../pages/Admin/Mentor/MentorDetails/MentorDetails";
import Course from "../pages/Admin/Course/Course";
import Video from "../pages/Admin/Course/Video/Video";
import CourseDetails from "../pages/Admin/Course/CourseDetails/CourseDetails";
import RegistrationRequest from "../pages/Admin/RegistrationRequest/RegistrationRequest";
import CreateCourse from "../pages/Admin/Course/CreateCourse/CreateCourse";
import PurchaseRequest from "../pages/Admin/PurchaseRequest/PurchaseRequest";
import PurchaseRequestDetails from "../pages/Admin/PurchaseRequest/PurchaseRequestDetails/PurchaseRequestDetails";
import RegistrationRequestDetails from "../pages/Admin/RegistrationRequest/RegistrationRequestDetails/RegistrationRequestDetails";
import Lookup from "../pages/Admin/Lookup/Lookup";
import Payments from "../pages/Admin/Payments/Payments";

var AdminRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <AdminDashboard />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "requests",
    name: "Registration Requests",
    element: <RegistrationRequest />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "purchase-requests",
    name: "Purchase Requests",
    element: <PurchaseRequest />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "course-category",
    name: "Course Category",
    element: <CourseCategory />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "organizations",
    name: "Organizations",
    element: <Organization />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "interests",
    name: "Interests",
    element: <Interest />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "skills",
    name: "Skills",
    element: <Skill />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "customers",
    name: "Customers",
    element: <Users />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "coordinators",
    name: "Coordinators",
    element: <Staff />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "mentors",
    name: "Mentors",
    element: <Mentor />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "courses",
    name: "Courses",
    element: <Course />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lookups",
    name: "Lookups",
    element: <Lookup />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "payments",
    name: "Payments",
    element: <Payments />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  
  {
    path: "mentors/:id",
    name: "Mentor Details",
    element: <MentorDetails />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },  
  {
    path: "courses/:id/videos",
    name: "Videos",
    element: <Video />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },  
  {
    path: "courses/:id",
    name: "Course",
    element: <CourseDetails />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "courses/create-course",
    name: "New Course",
    element: <CreateCourse />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "purchase-requests/:id",
    name: "Purchase Requests",
    element: <PurchaseRequestDetails />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "requests/:id",
    name: "Request Details",
    element: <RegistrationRequestDetails />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default AdminRoutes;
